import { IconName } from '@fortawesome/fontawesome-svg-core'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'
// import { faBoxTaped } from '@fortawesome/pro-light-svg-icons'

interface IconWithBackgroundProps {
    // icon?: IconProp
    size?: 'small' | 'extraSmall' | 'medium'
    iconName?: IconName | string
    spin?: boolean
    className?: string
}
// DEPRECATION OF FontAwesomeIcon
const IconWithBackground = ({ size, iconName, spin, className }: IconWithBackgroundProps) => {
    return (
        <div
            id='IconWithBackground'
            className={`bgBlushPrimaryColor ccText border-full flex-shrink-0 ${
                size === 'small'
                    ? 'w-8 h-8'
                    : size === 'extraSmall'
                      ? 'w-6 h-6'
                      : size === 'medium'
                        ? 'w-10 h-10'
                        : 'w-12 h-12'
            } rounded-full flex items-center justify-center ${className}`}
        >
            {
                iconName && (
                    <DynamicFaIcon
                        className={`${size === 'small' ? 'text-sm' : size === 'extraSmall' ? 'text-xs' : size === 'medium' ? 'text-lg' : 'text-xl'}`}
                        spin={spin}
                        iconName={iconName === 'geen' ? 'box-taped' : iconName}
                    />
                )
                // : (
                //     <FontAwesomeIcon
                //         className={`${size === 'small' ? 'text-sm' : size === 'extraSmall' ? 'text-xs' : 'text-xl'}`}
                //         icon={icon ? icon : faBoxTaped}
                //         spin={spin}
                //     />
                // )
            }
        </div>
    )
}

export default IconWithBackground
